//Principais
import { Component, Inject, LOCALE_ID, ViewChild, ChangeDetectorRef, HostListener, OnInit } from '@angular/core';
import { DataTableDirective } from "angular-datatables";
import { ADTSettings } from "angular-datatables/src/models/settings";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { Subject, lastValueFrom } from "rxjs";
//Métodos
import { Diretoria } from 'src/app/shared/models/diretoria/Diretoria';
import { Escola } from 'src/app/shared/models/escola/Escola';
import { Polo } from "src/app/shared/models/polo/Polo";
import { AtribuicaoLoginSed, UserLoginSed } from "src/app/shared/models/sed/UserLogin";
//Serviços
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { ConvivaErrorHandlingService } from "src/app/shared/services/convivaErrorHandlingService";
import { EscolaService } from "src/app/shared/services/escola.service";
import { PsicologoService } from "src/app/shared/services/psicologo.service";

import { formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { FiltroPadrao } from 'src/app/shared/models/filtro-padrao/filtroPadrao';
import { Atividade } from 'src/app/shared/models/psicologo/AtividadePsicologo';
import { DashboardAtividadePOC } from 'src/app/shared/models/psicologo/listar-atividades-POCs';
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';

@Component({
  templateUrl: './dashboard-visitas.component.html',
  styleUrls: ['./dashboard-visitas.component.scss'],
  standalone: true,
  imports: [angularCommonImports, convivaCommonImports, libsCommonImports]
})

export class PageDashboardPocVisitasComponent implements OnInit {

  //Variaveis de Login
  public userLogado: UserLoginSed | null;
  public atribuicoesLogin: AtribuicaoLoginSed;

  // Variaveis do Grid DataTable
  public dtOptions: any = {};
  public dtTrigger: Subject<ADTSettings> = new Subject<ADTSettings>();
  @ViewChild(DataTableDirective, { static: false })
  public dtElement: DataTableDirective;
  public isDtInitialized: boolean = false;
  public exibirEscola: boolean = false;

  //Modal
  public showModalConfirmacao: boolean;
  public showModalComentario: boolean;
  public comentarioModal: string;
  public tipoPec: boolean;

  //Variaveis filtro
  public filtros?: FiltroPadrao;

  constructor(
    private spinnerService: NgxSpinnerService,
    private authService: AuthService,
    private psicologoService: PsicologoService,
    private ConvivaErrors: ConvivaErrorHandlingService,
    private toastr: ToastrService,
    private escolaService: EscolaService,
    private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private locale: string,
    private router: Router

  ) {
    this.userLogado = this.authService.getUser();

    if (this.userLogado != null && !this.userLogado.flPsicologo) {
      this.atribuicoesLogin = this.userLogado?.DadosUsuario[0];
    }
  }

  //Forms
  public formDashboard!: FormGroup;
  public get form() { return this.formDashboard.controls; }
  public submitted: boolean;

  //Listagens
  public polos: Polo[] = [];
  public diretorias: Diretoria[] = [];
  public escolas: Escola[] = [];
  public poloLogado: Polo;
  public lstAtividadePOC: DashboardAtividadePOC[] = [];
  public atividadeParaExcluir: number | null = null;

  ngOnInit(): void {
    this.inicializar();
  }

  private async inicializar(): Promise<void> {

    ($.fn.dataTable.ext.type.order as any)['date-dd-mm-yyyy-pre'] = (data: string) => {
      const parts = data.split('/');
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);
      return new Date(year, month, day).getTime();
    };

    this.dtOptions = {
      deferRender: true,
      destroy: true,
      retrieve: true,
      processing: true,
      paging: true,
      dom: 'Bfrtip',
      order: [[3, 'asc']],
      columnDefs: [
        { targets: 3, type: 'date-dd-mm-yyyy' }, // Define a coluna como do tipo personalizado
      ],
      language: {
        url: 'https://cdn.datatables.net/plug-ins/1.11.5/i18n/pt-BR.json'
      },
      lengthMenu: [
        [10, 25, 50, -1],
        ['10 linhas', '25 linhas', '50 linhas', 'Tudo']
      ],
      buttons: [
        'pageLength',
        {
          extend: 'print',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 7]
          }
        },
        {
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 7]
          }
        },
        {
          extend: 'pdf',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 7]
          }
        }
      ],
      // columns: [
      //   { data: 'codigoAtividadePsicologo' },
      //   { data: 'ds_TP_ACAO_ATIVIDADE' },
      //   { data: 'codigoChamado' },
      //   {
      //     data: 'dataAtividadePsicologo',
      //     render: function (data: any, type: any, row: any) {
      //       if (type === 'display' || type === 'filter') {
      //         return moment(data, 'DD/MM/YYYY').format('DD/MM/YYYY'); // Formato de exibição
      //       }
      //       return moment(data, 'DD/MM/YYYY').toDate(); // Formato interno para ordenação
      //     }
      //   },
      //   { data: 'timeAtividadePsicologo' },
      //   { data: 'sT_APROVACAO_PEC' },
      //   { data: 'estrelasAvaliacaoPEC' },
      //   { data: 'professorPOC' },
      //   { data: 'acoes' }
      // ],
    };
    //Formulario de Pesquisa
    this.formDashboard = new FormGroup({
      codigoPolo: new FormControl(null, [Validators.required]),
      codigoDiretoria: new FormControl(null, [Validators.required]),
      codigoEscola: new FormControl(null),
      dataInicio: new FormControl(null),
      dataFim: new FormControl(null)
    });

    if (this.userLogado?.codigoPerfil === 1477) {
      this.formDashboard.get('codigoPolo')?.clearValidators();
      this.formDashboard.get('codigoDiretoria')?.clearValidators();
    } else {
      this.formDashboard.get('codigoPolo')?.setValidators([Validators.required]);
      this.formDashboard.get('codigoDiretoria')?.setValidators([Validators.required]);
    }

    this.formDashboard.get('codigoPolo')?.updateValueAndValidity();
    this.formDashboard.get('codigoDiretoria')?.updateValueAndValidity();

    if (!this.userLogado?.codigoPolo && this.userLogado?.codigoDiretoria && this.userLogado?.codigoDiretoria > 0) {
      await this.getPoloPorDiretoria(this.userLogado?.codigoDiretoria);
      if (this.userLogado?.codigoPolo > 0) {
        await this.getDiretoriasEscolasPorPolo(true);
      } else
        this.form.codigoDiretoria.disable();
    }

    if (this.userLogado?.flPsicologo) {
      await this.getPoloDiretoriaPsicologo();
    }
    else {
      if (this.atribuicoesLogin.NumeroComportamento == 1) {
        await this.getPolosAdmin();
      }
      if (this.atribuicoesLogin.NumeroComportamento == 2) {
        await this.getPolosPerfilDiretor();
      }
      if (this.atribuicoesLogin.NumeroComportamento == 3 || this.atribuicoesLogin.NumeroComportamento == 4) {
        await this.getPolosPerfilProfessor();
      }
    }

    // await this.getDiretoriasEscolasPorPolo(true);
    // await this.PesquisarVisitas(true);

    const currentPage = this.userLogado?.currentPage == undefined ? 0 : this.userLogado?.currentPage;

    // Esperar que la DataTable se haya inicializado completamente
    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        this.goToPage(currentPage);
      }).catch((error) => {
        console.error("Error al inicializar la tabla: ", error);
      });
    }

  }

  public OnChangePolo() {

    const codigoPolo = this.formDashboard.get('codigoPolo')?.value;
    if (this.userLogado !== null) {
      this.userLogado.codigoPolo = codigoPolo == null ? 0 : codigoPolo;
      this.authService.setUser(this.userLogado);
    }

    if (codigoPolo != null) {
      this.getDiretoriasPorPolo();
    } else {
      this.zerarDiretoria();
    }
    this.zerarEscola();
  }

  public async getPoloPorDiretoria(codigoDiretoria: number) {
    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getPolos(codigoDiretoria))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.poloLogado = response.data[0];
    if (this.userLogado) {
      this.userLogado.codigoPolo = response.data[0].codigoPolo == null ? 0 : response.data[0].codigoPolo;
      this.authService.setUser(this.userLogado);
    }
    this.spinnerService.hide();
  }

  public async getDiretoriasPorPolo(diretoriaLogada: boolean = false) {
    if (this.userLogado?.codigoPolo) {
      this.zerarDiretoria();
      this.spinnerService.show();
      const response = await lastValueFrom(this.psicologoService.getDiretoriaPorPolo(this.userLogado!.codigoPolo))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });
      if (!response.isSucess) {
        // this.showPesquisa = false;
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }
      this.diretorias = response.data;
      this.form.codigoDiretoria.enable();
      this.ativaDiretoria();
      this.getEscolasPorDiretoria();
      this.spinnerService.hide();
    }

    if (this.userLogado !== null) {
      this.userLogado.codigoDiretoria = this.userLogado.codigoDiretoria == null ? 0 : this.userLogado.codigoDiretoria;
      this.authService.setUser(this.userLogado);
    }
  }
  public zerarDiretoria() {
    this.diretorias = [];
    this.formDashboard.get('codigoDiretoria')?.patchValue(null);
  }
  public ativaDiretoria() {
    const diretoria = this.diretorias.filter(s => s.codigoDiretoria == this.userLogado?.codigoDiretoria);

    if (this.userLogado?.codigoDiretoria && this.userLogado?.codigoDiretoria > 0 && diretoria.length > 0) {
      this.formDashboard.get('codigoDiretoria')?.setValue(this.userLogado?.codigoDiretoria);

    }

    const polo = this.polos.filter(s => s.codigoPolo == this.userLogado?.codigoPolo);
    if (this.userLogado?.codigoPolo && this.userLogado?.codigoPolo > 0 && polo.length > 0) {
      this.formDashboard.get('codigoPolo')?.setValue(this.userLogado?.codigoPolo);
    }

  }
  public async getEscolasPorDiretoria(inicio = false) {
    if (this.userLogado !== null && !inicio) {
      this.userLogado.codigoEscola = this.form.codigoDiretoria.value == null ? 0 : this.userLogado.codigoEscola;
      this.authService.setUser(this.userLogado);
    }
    if (this.userLogado?.codigoDiretoria && this.userLogado.codigoDiretoria > 0) {
      this.form.codigoDiretoria.setValue(this.userLogado?.codigoDiretoria);
    }
    if (this.form.codigoDiretoria.value) {

      this.spinnerService.show();
      this.zerarEscola();
      const response = await lastValueFrom(this.escolaService.getEscolasPorCodigoDiretoria(this.form.codigoDiretoria.value))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });
      if (!response.isSucess) {
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }
      this.escolas = response.data;
      this.ativaEscola();
      this.spinnerService.hide();
    }

  }
  public zerarEscola() {
    this.escolas = [];
    this.formDashboard.get('codigoEscola')?.patchValue(null);
  }
  public ativaEscola() {
    if (this.escolas != undefined && this.userLogado?.codigoEscola != 0) {
      const escola = this.escolas.find(s => s.codigoEscola == this.userLogado?.codigoEscola)
      if (escola != undefined) {
        this.formDashboard.get('codigoEscola')?.setValue(this.userLogado?.codigoEscola);
      }

    }
  }
  public async trocaDiretoria() {
    const codigoDiretoria = this.formDashboard.get('codigoDiretoria')?.value;
    if (this.userLogado !== null && codigoDiretoria != null) {
      this.userLogado.codigoDiretoria = codigoDiretoria == null ? 0 : codigoDiretoria;
      this.authService.setUser(this.userLogado);
    }
    if (codigoDiretoria != null)
      await this.getEscolasPorDiretoria();
    else
      this.escolas = [];
    this.form.codigoEscola.setValue(null);
  }

  onChangeEscola() {
    const codigoEscola = this.formDashboard.get('codigoEscola')?.value;
    if (this.userLogado !== null && codigoEscola != null) {
      this.userLogado.codigoEscola = codigoEscola == null ? 0 : codigoEscola;
      this.authService.setUser(this.userLogado);
    }
  }
  public async getPolos() {
    this.spinnerService.show();

    const response = await lastValueFrom(this.psicologoService.getPolos())
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.polos = response.data;
    this.spinnerService.hide();
  }
  public async getDiretoriasEscolasPorPolo(inicio = false) {
    this.spinnerService.show();

    if (this.userLogado?.codigoPolo && this.userLogado?.codigoPolo > 0) {

      const response = await lastValueFrom(this.psicologoService.getDiretoriaEscolasPorPolo(this.userLogado!.codigoPolo))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });

      if (!response.isSucess) {
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }
      this.diretorias = response.data.diretorias;
      await this.getEscolasPorDiretoria(inicio);
      this.form.codigoDiretoria.enable();
      this.ativaDiretoria();
    }

    this.spinnerService.hide();
  }
  public async PesquisarVisitas(flagInit: boolean = false) {

    this.spinnerService.show();


    if (this.userLogado !== null && !flagInit) {
      this.userLogado.codigoEscola = this.form.codigoEscola.value == null ? 0 : this.form.codigoEscola.value;
      this.userLogado.codigoDiretoria = this.form.codigoDiretoria.value == null ? 0 : this.form.codigoDiretoria.value;
      this.userLogado.codigoPolo = this.form.codigoPolo.value == null ? 0 : this.form.codigoPolo.value;
      this.authService.setUser(this.userLogado);

    }

    const parametros = this.SetParametrosAtividade();
    
    this.submitted = true;
    if (this.formDashboard.invalid) {
      this.spinnerService.hide();
      return;
    }


    const response = await lastValueFrom(this.psicologoService.getDashboardAtividadePOCs(parametros)).catch((err) => {
      this.spinnerService.hide();
      return this.ConvivaErrors.handleResultError(err);
    });
    if (!response.isSucess) {
      this.toastr.error(response.message);
    }
    this.spinnerService.hide();
    this.lstAtividadePOC = response.data;

    if (this.lstAtividadePOC.length == 0) {
      this.toastr.warning("Não existem atividades para essa pesquisa");
    }

    if (this.isDtInitialized && this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.isDtInitialized = false;
      }).catch(() => {
        this.isDtInitialized = false;
      });
    }

    setTimeout(() => {
      this.isDtInitialized = true;
      this.dtTrigger.next(this.dtOptions);
    }, 100);

    setTimeout(() => {
      const currentPage = this.userLogado?.currentPage == undefined ? 0 : this.userLogado?.currentPage;
      if (this.dtElement && this.dtElement.dtInstance) {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          this.goToPage(currentPage);
        }).catch((error) => {
          console.error("Error al inicializar la tabla: ", error);
        });
      }
    }, 200);

  }
  public SetParametrosAtividade(): Atividade {
    const atividade = new Atividade();
    atividade.codigoPolo = this.filtros?.codigoPolo;
    atividade.codigoDiretoria = this.filtros?.codigoDiretoria;
    atividade.codigoEscola = this.filtros?.codigoEscola;
    // Período da seção "Pesquisar por período" (form) tem prioridade sobre o filtro-padrao
    const inicio =
      this.form?.dataInicio?.value ?? this.filtros?.fpDataInicio ?? null;
    const fim = this.form?.dataFim?.value ?? this.filtros?.fpDataFim ?? null;
    atividade.dataInicio = this.toDateInicioDia(inicio);
    atividade.dataFim = this.toDateFimDia(fim);

    return atividade;
  }

  /** Converte valor de <input type="date"> ou Date para início do dia (API). */
  private toDateInicioDia(value: string | Date | null | undefined): Date | undefined {
    if (value == null || value === '') {
      return undefined;
    }
    if (value instanceof Date) {
      const d = new Date(value);
      d.setHours(0, 0, 0, 0);
      return d;
    }
    const s = String(value).trim();
    if (!s) {
      return undefined;
    }
    const d = new Date(`${s}T00:00:00`);
    return Number.isNaN(d.getTime()) ? undefined : d;
  }

  /** Fim do dia local para o backend usar <= e incluir todo o último dia do período. */
  private toDateFimDia(value: string | Date | null | undefined): Date | undefined {
    if (value == null || value === '') {
      return undefined;
    }
    if (value instanceof Date) {
      const d = new Date(value);
      d.setHours(23, 59, 59, 999);
      return d;
    }
    const s = String(value).trim();
    if (!s) {
      return undefined;
    }
    const d = new Date(`${s}T23:59:59.999`);
    return Number.isNaN(d.getTime()) ? undefined : d;
  }
  public getDate(data?: Date) {
    if (data == undefined) return;
    return formatDate(data, 'dd/MM/yyyy', this.locale);
  }

  public AbreFechaModalConfirmacao(codigoAtividade?: number) {
    if (codigoAtividade !== undefined) {
      this.atividadeParaExcluir = codigoAtividade;
    }
    this.showModalConfirmacao = !this.showModalConfirmacao;
  }

  public async ExcluirAtividadePsicologo() {
    this.getActivePage();
    if (this.atividadeParaExcluir !== null) {
      this.spinnerService.show();

      const response = await lastValueFrom(this.psicologoService.setExcluirAtividadePOC(this.atividadeParaExcluir))
        .catch((err) => {
          return this.ConvivaErrors.handleResultError(err);
        });
      if (!response.isSucess) {
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }

      this.atividadeParaExcluir = null;
      this.toastr.success("Atividade excluida com sucesso!");
      this.atividadeParaExcluir = null;
      this.PesquisarVisitas();
      this.AbreFechaModalConfirmacao();
    }
  }
  @HostListener('click', ['$event'])
  onHostClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const link = target.closest('a.icones-acoes-link') as HTMLAnchorElement;

    if (!link) return;

    event.preventDefault();
    event.stopPropagation();

    const action = link.getAttribute('data-action');
    const rowElement = link.closest('tr');

    if (!rowElement) return;

    // Get the data-id attribute from the row or find the item by codigo
    const codigoAtividadeText = rowElement.querySelector('td')?.textContent?.trim();
    const codigoAtividade = codigoAtividadeText ? parseInt(codigoAtividadeText, 10) : null;

    if (!codigoAtividade) return;

    const item = this.lstAtividadePOC.find(a => a.codigoAtividadePsicologo === codigoAtividade);

    if (!item) return;

    switch(action) {
      case 'visualizar':
        this.AbrirVisualizar(item);
        break;
      case 'aprovacao':
        this.AbrirAprovacao(item);
        break;
      case 'excluir':
        this.AbreFechaModalConfirmacao(item.codigoAtividadePsicologo);
        break;
    }
  }

  public AbrirAprovacao(item: any) {
    this.getActivePage();
    this.router.navigate(['/aprovacao-visitas-professor-poc/', item.codigoAtividadePsicologo]);
  }

  public AbrirVisualizar(item: any) {
    this.getActivePage();
    this.router.navigate(['/visualizar-atividade-professor-poc/', item.codigoAtividadePsicologo]);    
  }


  public async getPoloDiretoriaPsicologo() {

    const response = await lastValueFrom(this.psicologoService.getPoloPsicologo(this.userLogado!.cpf)).catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.polos = [response.data];
    this.form.codigoPolo.setValue(this.polos[0].codigoPolo);
    this.form.codigoPolo.disable();

    await this.getDiretoriasPorPolo();
    // await this.getPocsPorPolo();
  }

  public async getPolosAdmin() {

    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getPolos())

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.polos = response.data;
    this.spinnerService.hide();

    if (this.userLogado?.codigoPolo != 0) {
      this.ativaPolo();
    }
    this.spinnerService.hide();
    // await this.getPocsPorPolo();
  }

  public async getPolosPerfilDiretor() {
    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getPolos(this.userLogado?.DadosUsuario[0].CodigoDiretoria)).catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.polos = response.data;
    this.form.codigoPolo.setValue(this.polos[0].codigoPolo);
    this.form.codigoPolo.disable();

    if (this.userLogado?.DadosUsuario[0].CodigoDiretoria != 0) {
      const todasDiretoriasDoUsuario: Diretoria[] = [];
      this.userLogado?.DadosUsuario.forEach(item => {
        const diretoria = new Diretoria();
        diretoria.codigoDiretoria = item.CodigoDiretoria;
        diretoria.nomeDiretoria = item.NomeDiretoria;
        todasDiretoriasDoUsuario.push(diretoria);
      });
      this.diretorias = todasDiretoriasDoUsuario;

      if (this.diretorias.length == 1) {
        this.form.codigoDiretoria.setValue(this.userLogado?.DadosUsuario[0].CodigoDiretoria);
      } else {
        this.form.codigoDiretoria.enable();
      }
      this.form.codigoEscola.enable();
      await this.getEscolasPorDiretoria();
      // await this.getPocsPorPolo();
    }

    this.spinnerService.hide();
  }

  public async getPolosPerfilProfessor() {


    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getPolos(this.userLogado?.DadosUsuario[0].CodigoDiretoria)).catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.polos = response.data;
    this.form.codigoPolo.setValue(this.polos[0].codigoPolo);
    this.form.codigoPolo.disable();
    const diretoriasEx: Diretoria[] = [];
    const dadosUsuario = this.userLogado?.DadosUsuario[0];
    if (dadosUsuario?.CodigoDiretoria != 0 && dadosUsuario?.CodigoEscola != 0) {
      this.userLogado?.DadosUsuario.forEach(item => {
        const diretoria = new Diretoria();
        diretoria.codigoDiretoria = item.CodigoDiretoria;
        diretoria.nomeDiretoria = item.NomeDiretoria;
        diretoriasEx.push(diretoria);
      });

      this.diretorias = diretoriasEx;

      if (this.userLogado?.codigoDiretoria && this.diretorias.some(x => x.codigoDiretoria == this.userLogado?.codigoDiretoria)) {
        this.form.codigoDiretoria.setValue(this.userLogado?.codigoDiretoria);
      }

      if (this.diretorias.length === 1) {
        this.form.codigoDiretoria.disable();
      }

    }
    this.spinnerService.hide();
  }

  public ativaPolo() {
    if (this.userLogado?.codigoPolo != undefined)
      this.formDashboard.get('codigoPolo')?.setValue(this.userLogado?.codigoPolo);

    if (this.userLogado !== null && this.userLogado)
      this.authService.setUser(this.userLogado);
  }

  public getAprovacaoStatus(status: number | null): string {
    if (status === 1) {
      return 'Aprovado';
    } else if (status === 2) {
      return 'Aprovado com melhoria';
    } else if (status === 3) {
      return 'Não Aprovado';
    } else if (status === null) {
      return 'Não Analisado';
    }
    return '';
  }

  public displayComentario(comentario: string, tipoPEC: boolean) {
    if (comentario === null) {
      this.toastr.error('Sem comentário');
    }
    this.showModalComentario = true;
    this.tipoPec = tipoPEC;
    this.comentarioModal = comentario;
  }
  public FecharModalComentario() {
    this.showModalComentario = false;
  }

  // Novo método para obter a página ativa
  public getActivePage(): void {
    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        const activePage = dtInstance.page();
        if (this.userLogado) {
          this.userLogado.currentPage = activePage;
          this.authService.setUser(this.userLogado);
        }
      });
    }
  }

  // Novo método para mover-se para uma página específica
  goToPage(page: number) {
    // Si la tabla no está inicializada, espera 100 ms y vuelve a intentar.
    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        // Cambio de página después de un pequeño retraso
        setTimeout(() => {
          dtInstance.page(page).draw('page');
        }, 500); // Aquí el retraso es de 500ms
      }).catch((error) => {
        console.error("Error al inicializar la tabla: ", error);
      });
    } else {
      setTimeout(() => this.goToPage(page), 500); // Intentar de nuevo después de 500ms
    }
  }

  async listeningFiltroEmitter(filtroPadrao: FiltroPadrao) {
    this.filtros = filtroPadrao;

    // Actualizar formulario con valores de filtros
    if (this.filtros.codigoPolo) {
      this.formDashboard.get('codigoPolo')?.setValue(this.filtros.codigoPolo);
    }
    if (this.filtros.codigoDiretoria) {
      this.formDashboard.get('codigoDiretoria')?.setValue(this.filtros.codigoDiretoria);
    }
    if (this.filtros.codigoEscola) {
      this.formDashboard.get('codigoEscola')?.setValue(this.filtros.codigoEscola);
    }
    // Sync date values from filter component to dashboard form
    if (this.filtros.fpDataInicio) {
      this.formDashboard.get('dataInicio')?.setValue(this.filtros.fpDataInicio);
    }
    if (this.filtros.fpDataFim) {
      this.formDashboard.get('dataFim')?.setValue(this.filtros.fpDataFim);
    }
    await this.PesquisarVisitas();
  }

}
